export default __webpack_public_path__ + "static/user5-1b8d97d74a3239e3f5b8e53114363d2c.jpg";